import { useParams } from 'react-router-dom'

import SignedInvoiceDetail from 'modules/expenses/pages/SignedInvoicesDetail'

const SignedInvoiceDetailPage = () => {
  const { invoiceId } = useParams()
  if (!invoiceId) {
    throw new Error('Required invoiceId param')
  }
  return <SignedInvoiceDetail invoiceId={invoiceId} />
}

export default SignedInvoiceDetailPage
